import React from 'react';
import { Icon, LinearGradient, withTheme } from '@draftbit/ui';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { screen: 'overview' };

const MenuButtonBlock = props => {
  const { theme } = props;
  const dimensions = useWindowDimensions();
  const [toggleSettings, setToggleSettings] = React.useState(false);
  const [toggleWhatIf, setToggleWhatIf] = props.setToggleWhatIf
    ? [
        props.toggleWhatIf !== undefined ? props.toggleWhatIf : false,
        props.setToggleWhatIf,
      ]
    : React.useState(false);

  return (
    <View>
      <LinearGradient
        color1={theme.colors.branding.primary}
        color2={theme.colors.branding.secondary}
        endY={100}
        startX={0}
        startY={0}
        {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear'].props}
        endX={0}
        style={StyleSheet.applyWidth(
          GlobalStyles.LinearGradientStyles(theme)['Blue Linear'].style,
          dimensions.width
        )}
      >
        <Icon
          size={24}
          {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
          name={'MaterialCommunityIcons/transfer'}
          style={StyleSheet.applyWidth(
            GlobalStyles.IconStyles(theme)['Menu Icon'].style,
            dimensions.width
          )}
        />
        <Text
          accessible={true}
          selectable={false}
          {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
          style={StyleSheet.applyWidth(
            GlobalStyles.TextStyles(theme)['Menu Text'].style,
            dimensions.width
          )}
        >
          {'Expenses'}
        </Text>
      </LinearGradient>
    </View>
  );
};

export default withTheme(MenuButtonBlock);
